
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Acne",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Acne.vue